import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Loading } from '../../../../../common/loading'
import {
  getNoDataComponent,
  handleIconDownload,
  reOrderDataByYear,
} from '../../helper'
import classes from '../../index.module.scss'
import { TableA } from './TableA'
import { TableB } from './TableB'
import { selectData, selectLoading } from './store/slice'

const QuickAssessment = ({ isDynamicReport, id }) => {
  const loading = useSelector(selectLoading)
  const data = useSelector(selectData)

  const isNoData = !data || !Object.keys(data).length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (loading) return <Loading />

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const dataTableBReorderByYear = data.indicatorsB?.map((item) => ({
    ...item,
    values: reOrderDataByYear([...item.values], 'year'),
  }))

  return (
    <>
      <Element
        style={{ color: '#3A414B' }}
        className={`${classes.containerPanel2} ${classes.quickAssessmentContainer}`}
      >
        <Element
          style={{ color: '#191D25', fontSize: 14 }}
          className={classes.title}
        >
          <Translate value="financialAnalysis.OVERALL_ASSESSMENT" />
        </Element>
        <div className={classes.mt4}>
          <Element
            style={{ background: '#EDF5FE', borderLeft: '3px solid #0553A5' }}
            className={classes.itemInfo}
          >
            <span className="ml1">{data.overallAssessmentA?.content}</span>
          </Element>
        </div>
        <TableA data={data.indicatorsA} />
      </Element>

      <Element
        style={{ color: '#3A414B' }}
        className={`${classes.containerPanel2} ${classes.quickAssessmentContainer}`}
      >
        <Element
          style={{ color: '#191D25', fontSize: 14 }}
          className={classes.title}
        >
          <Translate value="financialAnalysis.OVERALL_ASSESSMENT" />
        </Element>
        <div className={classes.mt4}>
          <Element
            style={{ background: '#EDF5FE', borderLeft: '3px solid #0553A5' }}
            className={classes.itemInfo}
          >
            <span className="ml1">{data.overallAssessmentB?.content}</span>
          </Element>
        </div>
        <TableB
          data={dataTableBReorderByYear}
          isDynamicReport={isDynamicReport}
        />
      </Element>
      <div className={`pt1 pb1 fstItalic ${classes.px12}`}>
        <Translate
          value="financialAnalysis.BANK_QUICK_ASSESSMENT_NOTE"
          dangerousHTML
        />
      </div>
    </>
  )
}

export default QuickAssessment
